import { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as DeleteIcon } from '@elementary/common-ui/assets/16x16/delete-trash.svg';
import { ReactComponent as UndoIcon } from '@elementary/common-ui/assets/16x16/undo.svg';
import { ReactComponent as EditIcon } from '@elementary/common-ui/assets/edit.svg';
import {
  Autocomplete,
  Button,
  Chip,
  Flex,
  FlexSpace,
  IconButton,
} from '@elementary/common-ui/components';

const EditIconStyled = styled(EditIcon)`
  width: 12px;
`;

type Props = {
  value?: string;
  showApplyToAll?: boolean;
  isNew?: boolean;
  isDeleted?: boolean;
  onEdit: (val: string) => void;
  onDelete: () => void;
  onUndo: () => void;
  onApplyForAll?: () => void;
  options?: string[];
};

const ValueEditItem = ({
  value,
  showApplyToAll,
  isNew,
  isDeleted,
  onEdit,
  onDelete,
  onUndo,
  onApplyForAll,
  options = [],
}: Props) => {
  const [editMode, setEditMode] = useState(false);

  const handleChange = (val: string) => {
    if (!val) return;
    onEdit(val);
    setEditMode(false);
  };

  return (
    <FlexSpace
      aria-label="value-edit-item"
      sx={{ width: '100%', height: '32px' }}
    >
      {editMode ? (
        <Autocomplete
          sx={{
            width: editMode ? '152px' : 0,
            opacity: editMode ? 1 : 0,
            pointerEvents: editMode ? undefined : 'none',
          }}
          defaultValue={value}
          autoFocus
          freeSolo
          options={options}
          openOnFocus
          onChange={(_, val) => handleChange(val)}
          componentsProps={{ popper: { sx: { width: 'auto !important' } } }}
        />
      ) : (
        <Chip
          sx={{ maxWidth: '160px' }}
          label={value}
          customVariant={isNew ? 'dashed' : isDeleted ? 'crossed' : undefined}
        />
      )}

      <Flex sx={{ alignItems: 'center', gap: 1 }}>
        {showApplyToAll && (
          <Button variant="outlined" onClick={onApplyForAll}>
            Apply For All
          </Button>
        )}
        <Flex sx={{ alignItems: 'center' }}>
          {!isDeleted && (
            <>
              <IconButton onClick={() => setEditMode(true)}>
                <EditIconStyled />
              </IconButton>
              <IconButton onClick={onDelete}>
                <DeleteIcon />
              </IconButton>
            </>
          )}
          {isDeleted && (
            <IconButton onClick={onUndo}>
              <UndoIcon width={16} />
            </IconButton>
          )}
        </Flex>
      </Flex>
    </FlexSpace>
  );
};

export default ValueEditItem;
